module.exports = __webpack_public_path__ + "static/media/patzari-se-3-ufes.06496f61.jpg";